import { type FC, useEffect, useRef } from "react";

import {
  eventMarketsFromFilterParams,
  filterParamsFromEventMarkets,
} from "~/feature/event/components/MarketsDataGrid/requestParamsFromEventMarketsFilters";
import { useEventMarketsFilter } from "~/feature/event/providers/EventMarketsFiltersProvider";
import { useFilter } from "~/providers/FilterProvider";
import { useSavedFilters } from "~/providers/SavedFiltersProvider";
import { deepEqual } from "~/utils/deepEqual";

export const EventMarketsSavedFiltersSync: FC = () => {
  const { filters, isFiltersApplied, registerOnClearAllFilters } =
    useEventMarketsFilter();
  const { filters: dashboardFilters, updateFilters } = useFilter();
  const { setCurrentSavedFilter } = useSavedFilters();
  const hasMirroredMarketFilters = useRef(false);

  useEffect(() => {
    return registerOnClearAllFilters(() => {
      setCurrentSavedFilter(null);
    });
  }, [registerOnClearAllFilters, setCurrentSavedFilter]);

  useEffect(() => {
    if (!hasMirroredMarketFilters.current) {
      if (!isFiltersApplied) {
        return;
      }

      hasMirroredMarketFilters.current = true;
    }

    const nextParams = filterParamsFromEventMarkets(filters);
    const currentMarketParams = filterParamsFromEventMarkets(
      eventMarketsFromFilterParams(dashboardFilters)
    );

    if (!deepEqual(nextParams, currentMarketParams)) {
      updateFilters(nextParams);
    }
  }, [dashboardFilters, filters, isFiltersApplied, updateFilters]);

  return null;
};
